"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mealSlideData = void 0;
exports.mealSlideData = [
    {
        text: '一階「篝日」',
        src: './img/meal/meal-img03.webp',
        alt: '',
    },
    {
        text: '※お料理内容は季節により異なります',
        src: './img/meal/meal-img04.webp',
        alt: '',
    },
    {
        text: '※お料理内容は季節により異なります',
        src: './img/meal/meal-img05.webp',
        alt: '',
    },
    {
        text: '※お料理内容は季節により異なります',
        src: './img/meal/meal-img06.webp',
        alt: '',
    },
    {
        text: '※お料理内容は季節により異なります',
        src: './img/meal/meal-img07.webp',
        alt: '',
    },
    {
        text: '※お写真はイメージでございます',
        src: './img/meal/meal-img01.webp',
        alt: '',
    },
    {
        text: '※お写真はイメージでございます',
        src: './img/meal/meal-img02.webp',
        alt: '',
    },
];
